import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { Projectpendingjoiner } from './model/projectpendingjoiner';
import { OrgprojectpendingjoinerlistService } from './service/orgprojectpendingjoinerlist.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgprojectpendingjoinerlist',
  templateUrl: './orgprojectpendingjoinerlist.component.html',
  styleUrls: ['./orgprojectpendingjoinerlist.component.css']
})
export class OrgprojectpendingjoinerlistComponent implements OnInit ,OnChanges{
  @Output() pendingjoiners:Projectpendingjoiner[];
  @Input() projectId:string;
  @Input() pendingJoinerToAdd:Projectpendingjoiner;
  @Input() pendingJoinerToRemove:Projectpendingjoiner;
  @Output() acceptedJoiner = new EventEmitter<Projectpendingjoiner>();
  modalPerson:Projectpendingjoiner;
  showAcceptDecline:boolean;
  showModal:boolean;
  showPendingJoiners:boolean;
  constructor(
    private oppjsrv:OrgprojectpendingjoinerlistService,
    private auth:AuthorizationService) { }

  get canChangeAcceptDecline(){
    return this.showAcceptDecline ? false : this.auth.isAuthorized('projectacceptdeclinejoiners',this.projectId)
  }  
  ngOnInit() {
    this.showModal = false;
    this.showPendingJoiners = false;
    this.oppjsrv.getPendingJoiners(this.projectId).pipe(untilDestroyed(this)).subscribe(pjlist => {
      this.pendingjoiners = pjlist;
      //console.log('the joiners: ',this.pendingjoiners);
      if(this.pendingjoiners && this.pendingjoiners.length > 0){
        this.showPendingJoiners = true;
      }
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    //Add member to list when user want to join. Only look for project id if current value is set.
    if(changes.pendingJoinerToAdd && changes.pendingJoinerToAdd.currentValue && changes.pendingJoinerToAdd.currentValue.projectId == this.projectId){
      //console.log('incomming change',changes.pendingJoinerToAdd.currentValue);
      var joiner:Projectpendingjoiner ={
        date_showed_interest: new Date().toISOString(),
        fullname: changes.pendingJoinerToAdd.currentValue.fullname,
        im:changes.pendingJoinerToAdd.currentValue.im,
        email:changes.pendingJoinerToAdd.currentValue.email,
        phone:changes.pendingJoinerToAdd.currentValue.phone,
        personId:changes.pendingJoinerToAdd.currentValue.personId,
        projectId:changes.pendingJoinerToAdd.currentValue.projectId,
        projectrole:changes.pendingJoinerToAdd.currentValue.projectrole
      };
      this.pendingjoiners.push(joiner);
      this.showPendingJoiners = true;
    }
    if(changes.pendingJoinerToRemove && changes.pendingJoinerToRemove.currentValue && changes.pendingJoinerToRemove.currentValue.projectId == this.projectId){
      //Remove from list in UI
      this.pendingjoiners.splice(this.pendingjoiners.indexOf(changes.pendingJoinerToRemove.currentValue),1);
      
    }
    
  }
  acceptPendingJoiner(joiner:Projectpendingjoiner){
    this.oppjsrv.acceptPendingJoiner(this.projectId,joiner.personId).pipe(untilDestroyed(this)).subscribe(success =>{
      this.oppjsrv.saveRole(this.modalPerson).pipe(untilDestroyed(this)).subscribe(s => {
        this.modalPerson = new Projectpendingjoiner;
      });
      //Output the chosen one for adding to members
      this.acceptedJoiner.emit(joiner);
      //Remove from list in UI
      this.pendingjoiners.splice(this.pendingjoiners.indexOf(joiner),1);
      
      this.showModal = false;
    });
  }

  declinePendingJoiner(joiner:Projectpendingjoiner){
    this.oppjsrv.declinePendingJoiner(this.projectId,joiner.personId).pipe(untilDestroyed(this)).subscribe(success =>{
      //Remove from list in UI
      this.pendingjoiners.splice(this.pendingjoiners.indexOf(joiner),1);
      this.modalPerson = new Projectpendingjoiner;
      this.showModal = false;
    });
  }
  setModalPerson(joiner:Projectpendingjoiner){
    this.modalPerson = joiner;
    this.showModal = true;
  }

}
